import ArticleIcon from "@mui/icons-material/Article";
import {PuiDefaultPage, PuiGrid} from "@portnet/ui";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {generatePath, useNavigate, useParams} from "react-router-dom";
import AppTextField from "../../../../common/components/inputs/AppTextField";
import AppSection from "../../../../common/components/ui/AppSection";
import {getDetailPackageAction} from "../state/detailPackageActions";
import {
  NOUVELLE_SOUSCRIPTION_PAGE_ROUTE,
  PAIEMENT_SOUSCRIPTION_PAGE_ROUTE
} from "../../../../common/constants/routerConstants";
import AppButton from "../../../../common/components/ui/AppButton";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaymentsIcon from "@mui/icons-material/Payments";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";

const DetailPackagePage = () => {
  const { packageId } = useParams();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth.login);

  const {
    content: detailPackage,
    isLoading: isDetailPackageLoading,
    isSuccessed: isDetailPackageSuccessed,
  } = useSelector((state) => state.packages.detailPackage.package);


  const NavigationActions = () => {
    const navigate = useNavigate();
    return (
        <PuiGrid container>
            {!user.roles.includes("ROLE_VUPORTUARIA_ADMIN")&& !user.roles.includes("ROLE_VUPORTUARIA_USER_MANAGER") && (
                        <PuiGrid item>
                          <AppButton
                              color="primary"

                              startIcon={<AppRegistrationIcon />}
                              onClick={() => {
                                navigate(
                                    generatePath(NOUVELLE_SOUSCRIPTION_PAGE_ROUTE, {
                                      packageId,
                                    })
                                );
                              }}
                          >
                            Souscrire
                          </AppButton>
                        </PuiGrid>)}
        </PuiGrid>
    );
  };

  React.useEffect(() => {
    dispatch(getDetailPackageAction(packageId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PuiDefaultPage
      title="Détail d'un package"
      titleIcon={<ArticleIcon />}
      trace={["Consultation d'un package", "Détail d'un package"]}
      loading={isDetailPackageLoading}
      show={isDetailPackageSuccessed}
      topNav
      navActions={<NavigationActions />}
      bottomNav
      retour
      onRetour={() => navigate(-1)}
    >
      {isDetailPackageSuccessed && (
        <>
          <AppSection title="Information package">
            <PuiGrid container>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Type de paiement"
                  value={detailPackage.typePaiment.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Transaction autorisée"
                  value={detailPackage.typeTransactionAutorisee.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Nombre de transaction"
                  value={detailPackage.nbrTransaction}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Frais d'acces annuel(TTC)"
                  value={parseFloat( detailPackage.abonnementBase* 1.2).toFixed(2)}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Validité du package"
                  value={detailPackage.validiteePackage.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Début de validité"
                  value={detailPackage.debutValidite.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>

              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Statut du package"
                  value={detailPackage.statut.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Type de frais de service"
                  value={detailPackage.typeFraisService.description}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={4} md={4}>
                <AppTextField
                  label="Reconduction"
                  value={detailPackage.reconduction ? "Oui" : "Non"}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={6} md={6}>
                <AppTextField
                  label="Frais transaction en MAD"
                  value={detailPackage.fraisService}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12} sm={6} md={6}>
                <AppTextField
                  label="Code package"
                  value={detailPackage.code}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
              <PuiGrid item xs={12}>
                <AppTextField
                  label="Description du package"
                  value={detailPackage.description}
                  multiline
                  rows={6}
                  readOnly
                  formik={false}
                />
              </PuiGrid>
            </PuiGrid>
          </AppSection>
          {user.roles.includes("ROLE_VUPORTUARIA_ADMIN_TARIF") &&
            Boolean(detailPackage.souscriptions) && (
              <AppSection
                title="Souscriptions au package"
                sx={{ marginTop: 2 }}
              >
                <PuiGrid container>
                  <PuiGrid item xs={4}>
                    <AppTextField
                      label="Souscriptions"
                      value={detailPackage.souscriptions.length}
                      readOnly
                      formik={false}
                    />
                  </PuiGrid>
                  <PuiGrid item xs={4}>
                    <AppTextField
                      label="En cours"
                      value={detailPackage.souscriptions.length}
                      readOnly
                      formik={false}
                    />
                  </PuiGrid>
                  <PuiGrid item xs={4}>
                    <AppTextField
                      label="Expirés"
                      value={0}
                      readOnly
                      formik={false}
                    />
                  </PuiGrid>
                </PuiGrid>
              </AppSection>
            )}
        </>
      )}
    </PuiDefaultPage>
  );
};

export default DetailPackagePage;
